import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { mediasActions } from '../actions/medias.actions';
import { PaginationParams } from '../types';
import { selectItems, selectLimit, selectLoaded, selectLoading, selectPage, selectTotal } from '../selectors/medias.selector';

@Injectable({
    providedIn: 'root',
})
export class MediasFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly items$ = this.store.select(selectItems);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly items = this.store.selectSignal(selectItems);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);

    getMedia(value: PaginationParams): void {
        this.store.dispatch(mediasActions.getMedia({ value }));
    }

    clear(): void {
        this.store.dispatch(mediasActions.clear());
    }
}
